

const FieldActivityDetailsTestData = {
    "Id": 220357,
    "ModifiedLocally": false,
    "ModifiedDateTime": null,
    "CompletedDateTime": null,
    "Address": "3980 E GRAYTHORN ST",
    "Comments": null,
    "ContainerActionType": "PWDELIVER",
    "ContainerActionDisplay": "DELIVER",
    "ContainerCount": 1,
    "ContainerSize": 60,
    "ContainerType": "REFUSE",
    "DateCreated": "2021-01-11T10:23:15",
    "DateScheduled": "2021-01-12T00:00:00",
    "FieldActivityId": "7249601984",
    "Type": "PWCONT",
    "Instructions": "Joseph Adams, (323) 423-4234, Apt, Suite, Unit# , ADDTL CONT, CRM 2021-058928",
    "Latitude": 33.307104,
    "Longitude": -111.999937,
    "PartToRepair": "",
    "RouteNumber": "5",
    "Sequence": 19,
    "ServicePoint": "7244700971",
    "Status": "PENDING",
    "FieldActivityRemark": "",
    "FieldActivityRemarkValue": "",
    "MainPersonId": "1922442337",
    "Saved": false,
    "Synced": true,
    "SolidWasteContainerId": "94f0297f-3154-eb11-8fec-00155d30a1e3",
    "ServiceRequestId": "ea47319a-3154-eb11-a812-001dd801582c",
    "ServiceRequestNumber": "2021-058928",
    "DynamicsClosureStatus": "",
    "SharePointPhotoId": ""
};

export default FieldActivityDetailsTestData;